import { render, staticRenderFns } from "./DlgEventDelete.vue?vue&type=template&id=71ea182e&scoped=true"
import script from "./DlgEventDelete.vue?vue&type=script&lang=ts"
export * from "./DlgEventDelete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ea182e",
  null
  
)

export default component.exports